import { Colors } from '@sternum/web/components/theme/constants';
import { getMappedValue } from '@sternum/web/utils';

import { AlertSeverity } from '../models';

export function getSeverityColor(severity: AlertSeverity) {
  return getMappedValue<AlertSeverity>(
    {
      [AlertSeverity.High]: Colors.PinkDark,
      [AlertSeverity.Low]: Colors.GreenDark,
      [AlertSeverity.Regular]: Colors.GreyDarker,
      [AlertSeverity.Medium]: Colors.OrangeDark,
    },
    severity,
    '',
  );
}
